// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { productImageBadgesStyles } from "@insite/content-library/Components/ProductImageBadges";
import { css } from "styled-components";

productImageBadgesStyles.container = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 4px 8px;
    `,
};
productImageBadgesStyles.badgeImageProps = {
    style: {
        height: "23px",
        borderRadius: "4px",
    },
};
productImageBadgesStyles.imageItem = {
    css: css`
        justify-content: center;
    `,
};
